import { ColDef, ColGroupDef } from '@ag-grid-community/core';

import { genericGetAttributeColumns } from '@features/budget-attributes/attribute-columns';

import { LocalStorageKey } from '@shared/constants/localStorageKey';
import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';
import { Utils } from '@shared/utils/utils';

import { qcGetCostCategoryColumn } from './qc-cost-category-column';
import { QuarterCloseGridConfigContext } from './qc-grid-config-context';

export const qcAttributesColumnGroup = (
  ctx: QuarterCloseGridConfigContext,
  isFluxAnalysisAvailableAndOn: boolean
): ColGroupDef => {
  const isPivotSelected = !!ctx.attributeConfig.primaryAttribute?.attribute_name;
  const children: ColDef[] = [];
  const openByDefault =
    localStorage.getItem(LocalStorageKey.CLOSE_SUMMARY_VENDOR_CONTRACT_GROUP) === 'true';

  if (isPivotSelected) {
    children.push({
      ...qcGetCostCategoryColumn(ctx),
      columnGroupShow: 'open',
      hide: !openByDefault || isFluxAnalysisAvailableAndOn,
    });
  }

  children.push(
    ...genericGetAttributeColumns({
      attributeConfig: ctx.attributeConfig,
      colDefOverrides: {
        cellClass: getCellClassForGroups,
        columnGroupShow: 'open',
        headerClass: ['text-center'],
        hide: !openByDefault || isFluxAnalysisAvailableAndOn,
        minWidth: 70,
        resizable: true,
      },
      offset: 1,
      onlyPivot: null,
    })
  );
  children.sort((a, b) => Utils.localeAlphaNumSort(a.headerName || '', b.headerName || ''));

  return {
    children,
    headerClass: ['text-center', 'header-marker', 'green-marker'],
    headerName: 'Attributes',
    suppressStickyLabel: true,
  };
};
